/**
 * Listening, nothing stable yet.
 *
 * The hardest thing to get right about a listening app is proving it is alive without
 * saying anything. A static "listening…" label is indistinguishable from a hung tab; a
 * live level meter is a technical readout that invites the player to perform for it. So:
 * one dot, breathing at roughly a resting breath rate, with a shimmer ring behind it.
 *
 * No chord is shown here, ever. A guess displayed before the recogniser is sure is a
 * guess the player will play *around*, which corrupts the very thing being listened to.
 */

import { motion } from 'framer-motion';

export function ListeningPulse({ calm }: { calm: boolean }): React.JSX.Element {
  return (
    <li className="hc-rail__item hc-rail__item--current">
      <div className="hc-listening" data-testid="hc-listening" role="status">
        <span className="hc-listening__stage">
          <motion.span
            className="hc-listening__shimmer"
            aria-hidden="true"
            animate={calm ? { opacity: 0.18 } : { scale: [1, 1.6, 1], opacity: [0.22, 0.02, 0.22] }}
            transition={
              calm ? { duration: 0.2 } : { duration: 3.4, repeat: Infinity, ease: 'easeInOut' }
            }
          />
          <motion.span
            className="hc-listening__dot"
            aria-hidden="true"
            animate={calm ? { opacity: 0.7 } : { scale: [1, 1.14, 1], opacity: [0.62, 1, 0.62] }}
            transition={
              calm ? { duration: 0.2 } : { duration: 3.4, repeat: Infinity, ease: 'easeInOut' }
            }
          />
        </span>
        <span className="hc-listening__label">listening…</span>
      </div>
    </li>
  );
}
